import React from 'react';
import MainTabs from '../navigation/MainTabs';

export default function MainScreen() {
  return <MainTabs />;
}
